import Api from '../../services';

export const getUser = () => {
  return (dispatch) => {
    return Api.user.getUser().then((response) => {
      dispatch({
        type: 'GET_USER',
        data: response,
      });
      dispatch({
        type: 'SET_META_DATA',
        data: response,
      });
      return response;
    });
  };
};

export const updateUser = (data, params) => {
  return (dispatch) => {
    return Api.user.updateUser(data, params).then((response) => {
      dispatch({
        type: 'UPDATE_USER',
        data: response,
      });
      dispatch({
        type: 'SET_META_DATA',
        data: response,
      });
      return response;
    });
  };
};

export const uploadUserImage = (data) => {
  return (dispatch) => {
    return Api.user.uploadUserImage(data).then((response) => {
      dispatch({
        type: 'UPlOAD_USER_IMAGE',
        data: response,
      });
      return response;
    });
  };
};

export const becomeHost = () => {
  return (dispatch) => {
    return Api.user.becomeHost().then((response) => {
      dispatch({
        type: 'BECOME_A_HOST',
        data: response,
      });
      return response;
    });
  };
};

export const verifyPhoneNumber = (data) => {
  return (dispatch) => {
    return Api.user.verifyPhoneNumber(data).then((response) => {
      dispatch({
        type: 'VERIFY_PHONE_NUMBER',
        data: response,
      });
      dispatch({ type: 'RESET_META_DATA' });
      return response;
    });
  };
};

export const resendOtp = () => {
  return (dispatch) => {
    return Api.user.resendOtp().then((response) => {
      dispatch({
        type: 'RESEND_OTP',
        data: response,
      });
      return response;
    });
  };
};

export const confirmEmail = (params) => {
  return (dispatch) => {
    return Api.user.confirmEmail(params).then((response) => {
      dispatch({
        type: 'CONFIRM_EMAIL',
        data: response,
      });
      return response;
    });
  };
};

export const uploadIdentificationImage = (data) => {
  return (dispatch) => {
    return Api.user.uploadIdentificationImage(data).then((response) => {
      dispatch({
        type: 'UPlOAD_IDENTIFICATION_IMAGE',
        data: response,
      });
      return response;
    });
  };
};

export const getPublicProfile = (id) => {
  return (dispatch) => {
    return Api.user.getPublicProfile(id).then((response) => {
      dispatch({ type: 'GET_PUBLIC_PROFILE', data: response });
      return response;
    });
  };
};

export const getUserReviews = (id, params) => {
  return (dispatch) => {
    return Api.user.getUserReviews(id, params).then((response) => {
      dispatch({ type: 'GET_USER_REVIEWS', data: response });
      return response;
    });
  };
};
